<button [disabled]="disabled" [ngClass]="btnClasses ? btnClasses : ''" class="normal-btn btn-m fill-available" color="{{color!='basic'?color:''}}"
        mat-raised-button style="margin: 0.1rem;
  padding: 0;" type="button">
  <mat-icon [style.color]="iconColor != null ? iconColor : ''">{{ iconClasses }}</mat-icon>
</button>

